// 入场数据路由管理
export default{
    path: '/viteData',
    component: () => import('@/components/RouterView'),
    meta: {
        requireAuth: false
    },
    children:[{
        path:'',
        component: () => import('@/views/viteData/statistics.vue'),
        meta: {
            viteDataSecretKey: true
        },
    },{
        path:'login',
        component: () => import('@/views/viteData/login.vue'),
    }]
}